import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
//import { ModuleMasterService } from '../../services/moduleMaster/module-master.service';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { CommonService } from 'src/app/middleware/common/common.service';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { CreateModuleReqVM } from 'src/app/viewModels/moduleMaster/create-module-req-vm';
import { ModuleMasterService } from '../services/moduleMaster/module-master.service';

@Component({
  selector: 'app-edit-modules',
  templateUrl: './edit-modules.component.html',
  styleUrls: ['./edit-modules.component.scss']
})
export class EditModulesComponent implements OnInit {

  constructor(private fb: FormBuilder, private moduleService: ModuleMasterService, 
    private toastr: ToastrService, private statusConst: StatusConstant, 
    private loader: LoaderService, private commonService: CommonService) { 

      this.updateModuleform = this.fb.group({
        moduleName: ['', Validators.required],
        moduleRoute: ['', Validators.required],
        isActive: ['']
      });
      let data = [];
      data = this.commonService.getEditData();

      if(data !=null){
        this.isEdit = data[0];
        this.module = data[1];
       
        this.updateModuleDetail.moduleName = this.module.moduleName;
        this.updateModuleDetail.moduleRoute = this.module.moduleRoute;
        this.updateModuleDetail.moduleID = this.module.moduleID;
        this.updateModuleDetail.isActive = this.module.isActive;
        this.updateModuleDetail.isActive = this.module.isActive === 'Active' ? true : false;
      }     

    }

 
  updateModuleform: FormGroup;
  updateModuleDetail: CreateModuleReqVM = new CreateModuleReqVM();
  isEdit: boolean;
  module: any;
  updateModuleResponseHolder: any;
  @Output() closeSidePanel = new EventEmitter();
  

  ngOnInit(): void {
  }

  close() {
    //this.dialogRef.close();
    let closePanel = false;
    this.closeSidePanel.emit(closePanel);
  }

  updateModule() {
    let updateSelectedDetail = new CreateModuleReqVM();
    updateSelectedDetail = this.updateModuleDetail;
    this.loader.show();
    this.moduleService.updateModule(this.updateModuleDetail).subscribe(response => {
      this.updateModuleResponseHolder = response;
      this.loader.hide();
      if (this.updateModuleResponseHolder.status === this.statusConst.statusSuccess) {
        let closePanel = true;
        this.closeSidePanel.emit(closePanel);
        this.toastr.success("Updated successfully.", '', {
          timeOut: 3000,
        });
        //this.dialogRef.close(updateSelectedDetail);
      } else {
        this.toastr.error(this.updateModuleResponseHolder.message, '', {
          timeOut: 3000,
        });
      }
    });
  }

}
